import { UserService, UserSvcRole } from '@kp/rest-api-javascript-sdk';

import { PaginationFilter } from '../common';

export type UserRole = UserSvcRole;
type UserRoleInput = {
  userId: string;
  roleId: string;
};

export const getUserRoles = async (filter: PaginationFilter = {}) =>
  UserService.getRoles({ query: { skip: filter.skip, limit: filter.limit } });

/**
 * Add a new role to a user
 *
 * @param userId         The id of the user
 * @param roleId         The id of the role, which will be added to the user
 */
export const addUserRole = ({ userId, roleId }: UserRoleInput) =>
  UserService.postUsersByUserIdRolesByRoleId({
    path: { userId, roleId },
    body: {},
  });

/**
 * Delete a role from a user
 *
 * @param userId         The id of the user
 * @param roleId         The id of the role, which will be deleted from the user
 */
export const deleteUserRole = ({ userId, roleId }: UserRoleInput) =>
  UserService.deleteUsersByUserIdRolesByRoleId({ path: { userId, roleId } });
